module.exports = __webpack_public_path__ + "media/images/fundraise/fundraise-banner-sp-5820e5bbe19d77e928093812fc7302da.jpg";